import { combineReducers } from 'redux';
import update from 'react-addons-update';
import { buildOxygenObjects } from '../../utils/oxygenHelpers';
import {
  JSONAPI_CONFIGURE,
  ANALYTICS_CONFIGURE,
  OXYGEN_CONFIGURE_ASYNC_PENDING,
  OXYGEN_CONFIGURE_ASYNC_FULFILLED,
  OXYGEN_CONFIGURE_ASYNC_REJECTED,
  DOCUMENT_COLLECTION_CONFIGURE,
  DOCUMENT_CONFIGURE_PENDING,
  DOCUMENT_CONFIGURE_FULFILLED,
  DOCUMENT_CONFIGURE_REJECTED,
  SET_SHEETS_CONFIGURATION,
  DOCUMENTS_WITH_ISSUES_FETCH,
} from '../actions';

/* eslint-disable default-case */
const jsonapiConfigurationReducer = (state = null, action) => {
  switch (action.type) {
    case JSONAPI_CONFIGURE:
      return action.payload;
  }
  return state;
};

const analyticsConfigurationReducer = (state = null, action) => {
  switch (action.type) {
    case ANALYTICS_CONFIGURE:
      return action.payload;
  }
  return state;
};

const oxygenConfigurationReducer = (state = null, action) => {
  switch (action.type) {
    case OXYGEN_CONFIGURE_ASYNC_PENDING:
    case OXYGEN_CONFIGURE_ASYNC_REJECTED:
      break;
    case OXYGEN_CONFIGURE_ASYNC_FULFILLED:
      return buildOxygenObjects(action.payload);
  }
  return state;
};

const documentConfigurationReducer = (state = null, action) => {
  switch (action.type) {
    case DOCUMENT_CONFIGURE_PENDING:
    case DOCUMENT_CONFIGURE_REJECTED:
      break;
    case DOCUMENT_CONFIGURE_FULFILLED:
      return action.payload;
  }
  return state;
};

const documentCollectionReducer = (state = {}, action) => {
  switch (action.type) {
    case DOCUMENT_COLLECTION_CONFIGURE:
      return update(state, { $merge: action.payload });
  }
  return state;
};

const currentlyFetchingDocumentCollectionReducer = (state = [], action) => {
  switch (action.type) {
    case DOCUMENTS_WITH_ISSUES_FETCH:
      return action.payload;
    case DOCUMENT_COLLECTION_CONFIGURE:
      return state.filter(urn => urn === action.payload);
  }
  return state;
};

const initialSheetsConfigurationReducerState = {
  sheetList: [],
  currentSheets: [],
};

const sheetsConfigurationReducer = (state = initialSheetsConfigurationReducerState, action) => {
  switch (action.type) {
    case SET_SHEETS_CONFIGURATION:
      return action.payload;
  }
  return state;
};

export default combineReducers({
  jsonapi: jsonapiConfigurationReducer,
  analyticsConfig: analyticsConfigurationReducer,
  oxygen: oxygenConfigurationReducer,
  documentCollection: documentCollectionReducer,
  fetchingIssuesUrns: currentlyFetchingDocumentCollectionReducer,
  document: documentConfigurationReducer,
  sheetsConfig: sheetsConfigurationReducer,
});
